export default "__VITE_ASSET__4da843c8__"